/**
 * Modal Types and Enums
 *
 * Central definition of all modal names and base props.
 */

// Modal component props interface
export interface BaseModalProps {
  onClose: (stackProps?: Record<string, any>) => void;
  onUpdate?: (
    meta: Record<string, any>,
    modalStackProps?: Record<string, any>
  ) => void;
  stackSize?: number;
  [key: string]: any;
}

/**
 * ModalName enum - all available modals in the application
 */
export enum ModalName {
  // Shared modals
  CONFIRM = "Confirm",
  SCORES_EDIT = "ScoresEdit",
  DIMENSION_DETAILS = "DimensionDetails",
  NEW_ACCOUNT = "NewAccount",
  IMAGE_CROPPR_UPLOADER = "ImageCropperUploader",
  ATTACHMENT_UPLOAD = "AttachmentUpload",
  MEMBER = "Member",

  // Feature modals - Teams
  NEW_TEAM = "NewTeam",
  MODIFY_TEAM = "ModifyTeam",
  TEAM_PICKER = "TeamPicker",

  // Feature modals - Projects
  NEW_PROJECT = "NewProject",

  // Feature modals - Scorecards
  NEW_SCORECARD = "NewScorecard",
  SCORECARD = "Scorecard",
  CLONE_SCORECARD = "CloneScorecard",
  SCORECARD_PICKER = "ScorecardPicker",

  // Feature modals - Organization
  NEW_ORGANIZATION = "NewOrganization",

  // Feature modals - Profile
  CHANGE_PASSWORD = "ChangePassword",

  // Feature modals - People
  ADD_PEOPLE = "AddPeople",
  ADD_PEOPLE_V2 = "AddPeopleV2",
  // Feature modals - Assessments
  ASSESSMENT_ROW_DETAILS = "AssessmentRowDetails",

  // Legacy/Unused (return null)
  VIDEO_MODAL = "VideoModal",
  INVITE_REVIEWERS = "InviteReviewer",
  INVITE_PEOPLE = "InvitePeople",
  LEARN_MORE = "LearnMore",
  KEY_OBJECTIVES_EDIT = "KeyObjectivesEdit",
  REQUIREMENTS_EDIT = "RequirementsEdit",
  INVITE = "Invite",
  INFO = "Info",
  ASSESSMENT_REPORT_GENERATE = "AssessmentReportGenerate",
}

// Backward compatibility
export { ModalName as ModalFileName };
